/* eslint-disable max-len */
import { INTL_IDS } from './messages';

export const CHANGE_EMAIL_STEP_ONE = 'app/Register/ChangeEmail/CHANGE_EMAIL_STEP_ONE';
export const CHANGE_EMAIL_STEP_ONE_FAILURE = 'app/Register/ChangeEmail/CHANGE_EMAIL_STEP_ONE_FAILURE';
export const CHANGE_EMAIL_STEP_ONE_SUCCESS = 'app/Register/ChangeEmail/CHANGE_EMAIL_STEP_ONE_SUCCESS';

export const CHANGE_EMAIL_STEP_TWO = 'app/Register/ChangeEmail/CHANGE_EMAIL_STEP_TWO';
export const CHANGE_EMAIL_STEP_TWO_FAILURE = 'app/Register/ChangeEmail/CHANGE_EMAIL_STEP_TWO_FAILURE';
export const CHANGE_EMAIL_STEP_TWO_SUCCESS = 'app/Register/ChangeEmail/CHANGE_EMAIL_STEP_TWO_SUCCESS';

export const CHANGE_INPUT = 'app/Register/ChangeEmail/CHANGE_INPUT';
export const CHANGE_INPUT_ERROR = 'app/Register/ChangeEmail/CHANGE_INPUT_ERROR';

export const CHANGE_STEP = 'app/Register/ChangeEmail/CHANGE_STEP';

export const RESET_FORM_STATE = 'app/Register/ChangeEmail/RESET_FORM_STATE';
export const RESET_INPUT_ERRORS = 'app/Register/ChangeEmail/RESET_INPUT_ERRORS';
export const RESET_STATE = 'app/Register/ChangeEmail/RESET_STATE';
export const RESET_STATUS = 'app/Register/ChangeEmail/RESET_STATUS';

export const VERIFY_RECAPTCHA = 'app/Register/ChangeEmail/VERIFY_RECAPTCHA';
export const VERIFY_RECAPTCHA_FAILURE = 'app/Register/ChangeEmail/VERIFY_RECAPTCHA_FAILURE';
export const VERIFY_RECAPTCHA_SUCCESS = 'app/Register/ChangeEmail/VERIFY_RECATPCHA_SUCCESS';

// Messages
export const CHANGE_EMAIL_ERROR_MESSAGE = 'An error has occurred while attempting to change your email. Please try again later. If the issue continues to persist, please call Customer Service for assistance.';

export const CHANGE_EMAIL_CONFIRMATION_DICTIONARY = {
  bannerError: {
    header: INTL_IDS.CHANGE_EMAIL_BANNER_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.CHANGE_EMAIL_BANNER_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  serviceError: {
    header: INTL_IDS.CHANGE_EMAIL_SERVICE_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.CHANGE_EMAIL_SERVICE_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  success: {
    header: INTL_IDS.CHANGE_EMAIL_SUCCESS_HEADING,
    isSuccess: true,
    link: {
      label: INTL_IDS.CHANGE_EMAIL_SUCCESS_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
};

export const DEFAULT_CHANGE_EMAIL_ERRORS = {
  defaultChangeEmailStepOneErrors: {
    bannerError: [],
    loanNumber: '',
    ssnTin: '',
    username: '',
    zipCode: '',
  },
  defaultChangeEmailStepTwoErrors: {
    bannerError: [],
    confirmEmail: '',
    email: '',
    noError: '',
  },
};

export const VIEW_NAMESPACE_DICTIONARY = {
  1: 'changeEmailStepOne',
  2: 'changeEmailStepTwo',
  3: '',
};
